import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setSite, setDepartment } from "../../redux/slices/auth.feature";

import aplLogoTransparent from "../../i/apl-logo-transparent.png";
import DepartmentSelection from "./DepartmentSelection";
import NavBar from "./NavBar";
import SiteSelection from "./SiteSelection";
import Footer from "./Footerj";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { IRootState } from "../../types/redux/IRootStore";
import { useAppDispatch } from "../../redux/hooks";
import PasswordExpiryAlert from "./PasswordExpiryAlert";
import BsModal2 from "../common/Modals/BsModal2";

export const MasterTemplate = (props: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    const aplSettings = AplSettingsSelector();
    const authRedux = useSelector((state: IRootState) => state.auth);

    let setSiteId = (siteId: number) => {
        dispatch(setSite(siteId));
    };

    let setDepartmentId = (departmentId: number) => {
        dispatch(setDepartment(departmentId));
    };


    console.log()
    return (
        <React.Fragment>
            <PasswordExpiryAlert />

            <div className="pageOuter">
                <div className="header">
                    <div className="title">
                        {authRedux.token ? (
                            <Link to={"/"}>
                                <img src={aplLogoTransparent} alt="APL Logo" height="36px" />
                            </Link>
                        ) : (
                            <img src={aplLogoTransparent} alt="APL Logo" height="36px" />
                        )}
                    </div>

                    {authRedux.messageBanner && (
                        <div className="headerBanner" style={{ margin: "1px 1px 1px 1px", textAlign: "left", verticalAlign: "middle" }}>
                            {authRedux.messageBanner}
                        </div>
                    )}

                    <NavBar />
                    <div className="clearAll"></div>
                </div>

                <div className="page">
                    <DepartmentSelection
                        departments={aplSettings.departments}
                        selectedDepartmentId={aplSettings.departmentId}
                        onChangeDepartment={setDepartmentId}
                    ></DepartmentSelection>
                    <SiteSelection sites={aplSettings.sites} selectedSiteId={aplSettings.siteId} onChangeSite={setSiteId}></SiteSelection>
                    <div className="tab-filler">&nbsp;</div>
                    <div className="main" id="main-div">
                        {props.children}
                        <br />
                    </div>
                    <div className="clear"></div>
                    <Footer />
                </div>
            </div>

            <BsModal2 />
        </React.Fragment>
    );
};

export default MasterTemplate;
